module.exports = __webpack_public_path__ + "static/media/Knights Shield_4c.a171980d.svg";